import { useContext } from "react";
import useSWR from "swr";
import { DynamicsCompany } from "@attelas/shared";
import { TokenContext } from "../context/TokenContext";
import { environment } from "../config/environment";
import { swrFetcher } from "../services/queries";
import { ToastContext } from "../context/ToastContext";

export const useDynamicsSettings = (enable: boolean) => {
  const { token } = useContext(TokenContext);
  const { showToast } = useContext(ToastContext);

  const { data, isLoading, error } = useSWR<{ companies: DynamicsCompany[] }>(
    enable ? `${environment.apiUrl}/api/integrations/dynamics/settings` : null,
    (url: string) => swrFetcher(url, { headers: { Authorization: `Bearer ${token}` } }),
    {
      onError: () => {
        showToast("Settings failed to load, please try again later", "error");
      },
    }
  );

  return {
    settings: data,
    isLoading,
    isError: !!error,
  };
};
